import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState = {
  activationSuccess: false,
  activationFailure: false,
  consentInfo: null as { isMinor: boolean; maskedParentEmail: string; firstName: string } | null,
  consentInfoLoading: false,
  consentInfoError: false,
  consentSent: false,
  consentSendFailure: false,
};

export type ActivateState = Readonly<typeof initialState>;

// Actions

export const activateAction = createAsyncThunk('activate/activate_account', async (key: string) => axios.get(`api/activate?key=${key}`), {
  serializeError: serializeAxiosError,
});

export const fetchConsentInfo = createAsyncThunk(
  'activate/fetch_consent_info',
  async (activationKey: string) => axios.get<{ isMinor: boolean; maskedParentEmail: string; firstName: string }>(`api/parental-consent/info?activationKey=${activationKey}`),
  { serializeError: serializeAxiosError }
);

export const sendConsentEmail = createAsyncThunk(
  'activate/send_consent_email',
  async (activationKey: string) => axios.post(`api/parental-consent/send-email?activationKey=${activationKey}`),
  { serializeError: serializeAxiosError }
);

export const ActivateSlice = createSlice({
  name: 'activate',
  initialState: initialState as ActivateState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(activateAction.pending, state => {
        state.activationSuccess = false;
        state.activationFailure = false;
      })
      .addCase(activateAction.rejected, state => {
        state.activationFailure = true;
        state.activationSuccess = false;
      })
      .addCase(activateAction.fulfilled, state => {
        state.activationSuccess = true;
        state.activationFailure = false;
      })
      .addCase(fetchConsentInfo.pending, state => {
        state.consentInfoLoading = true;
      })
      .addCase(fetchConsentInfo.fulfilled, (state, action) => {
        state.consentInfoLoading = false;
        state.consentInfo = action.payload.data;
      })
      .addCase(fetchConsentInfo.rejected, state => {
        state.consentInfoLoading = false;
        state.consentInfoError = true;
      })
      .addCase(sendConsentEmail.fulfilled, state => {
        state.consentSent = true;
        state.consentSendFailure = false;
      })
      .addCase(sendConsentEmail.rejected, state => {
        state.consentSendFailure = true;
      });
  },
});

export const { reset } = ActivateSlice.actions;

// Reducer
export default ActivateSlice.reducer;
